import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investor-icon',
  templateUrl: './investor-icon.component.html',
  styles: []
})
export class InvestorIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
